exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-boot {\r\n    width: 56px;\r\n    height: 56px;\r\n    display: grid;\r\n    animation: spinner-boot 4s infinite;\r\n}\r\n\r\n    .spinner-boot::before,\r\n    .spinner-boot::after {\r\n        content: \"\";\r\n        grid-area: 1/1;\r\n        border: 9px solid;\r\n        border-radius: 50%;\r\n        border-color: #474bff #474bff #0000 #0000;\r\n        mix-blend-mode: darken;\r\n        animation: spinner-boot 1s infinite linear;\r\n    }\r\n\r\n    .spinner-boot::after {\r\n        border-color: #0000 #0000 #dbdcef #dbdcef;\r\n        animation-direction: reverse;\r\n    }\r\n\r\n@keyframes spinner-boot {\r\n    100% {\r\n        transform: rotate(1turn);\r\n    }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/common/loading.css
// module id = 364
// module chunks = 0